var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchXs = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 7.073a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-.243 4.172a5 5 0 1 1 1.414-1.414l2.87 2.869a1 1 0 0 1-1.415 1.414l-2.869-2.87Z",
  fill: "currentColor"
})));
export { SvgSearchXs as ReactComponent };